import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserRegister } from '../model/userRegister';
import { EscalationModel, WaiverModel } from '../model/incident';
import { AppreciationReportModel } from '../model/appreciation';
import { CancelReissueReportModel, CarrierWiseReportModel, CommonDashboardModel, CorpVsRetailModel, DestinationWiseReportModel, HotelWiseReportModel, LeadTimeModel, MissedSavingModel, ProductWiseReportModel, SaleModel } from '../model/sale';
import { CorporateRawData } from '../model/corporateRawData';
import { EditCorporateModel } from '../model/editCorporate';
@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  apiUrl = environment.serverUrl;
  constructor(private http: HttpClient) { }

  public getRoles(): Observable<any[]> {
    const url = this.apiUrl + `/public/roles`;
    return this.http.get<any[]>(url);
  }

  public userRegister(map: UserRegister, id) {
    const url = this.apiUrl + `/admin/register/${id}`;
    return this.http.post<any>(url, map);
  }

  public reportAccountList() {
    const url = this.apiUrl + `/reports/profile`;
    return this.http.get<any>(url);
  }
  public airlineCode() {
    const url = this.apiUrl + `/reports/airline-code`;
    return this.http.get<any>(url);
  }


  public destinationList() {
    const url = this.apiUrl + `/reports/destination`;
    return this.http.get<any>(url);
  }


  public exchangeList() {
    const url = this.apiUrl + `/reports/exchange`;
    return this.http.get<any>(url);
  }

  public statusList() {
    const url = this.apiUrl + `/reports/status`;
    return this.http.get<any>(url);
  }

  public transTypeList() {
    const url = this.apiUrl + `/reports/trans-type`;
    return this.http.get<any>(url);
  }
  public leadTimeList() {
    const url = this.apiUrl + `/reports/lead-time`;
    return this.http.get<any>(url);
  }

  public tourCodeList() {
    const url = this.apiUrl + `/reports/tour-code`;
    return this.http.get<any>(url);
  }


  public exceptionCodeList() {
    const url = this.apiUrl + `/reports/exception`;
    return this.http.get<any>(url);
  }
  public typeList() {
    const url = this.apiUrl + `/reports/type`;
    return this.http.get<any>(url);
  }

  public escalationCategoryList() {
    const url = this.apiUrl + `/reports/escalation-category`;
    return this.http.get<any>(url);
  }

  public escalationProfile() {
    const url = this.apiUrl + `/reports/escalation-profile`;
    return this.http.get<any>(url);
  }
  public appreciationProfile() {
    const url = this.apiUrl + `/reports/appreciation-profile`;
    return this.http.get<any>(url);
  }
  public leadTime() {
    const url = this.apiUrl + `/reports/lead-time`;
    return this.http.get<any>(url);
  }

  public logAppfAccountList() {
    const url = this.apiUrl + `/admin/account-list`;
    return this.http.get<any>(url);
  }

  detailReportAccountList(account: string) {
    return this.http.get<any>(`${this.apiUrl}/admin/account-detail/${account}`);
  }
  detailLogApprAccountList(account: string) {
    return this.http.get<any>(`${this.apiUrl}/admin/account-detail/${account}`);
  }

  public getEscalationReportList(id,map: EscalationModel) {
    const url = this.apiUrl + `/reports/escalation-report/${id}`;
    return this.http.post<any>(url, map);
  }

  public getOpenEscalation(id,map: EscalationModel) {
    const url = this.apiUrl + `/reports/open-escalation/${id}`;
    return this.http.post<any>(url, map);
  }
  public userOpenEscalation(id) {
    const url = this.apiUrl + `/reports/user-open-escalation/${id}`;
    return this.http.get<any>(url);
  }

  public getWaiverReportList(id,map: WaiverModel) {
    const url = this.apiUrl + `/reports/waiver-report/${id}`;
    return this.http.post<any>(url, map);
  }

  public getAppreciationReportList(id,map: AppreciationReportModel) {
    const url = this.apiUrl + `/reports/appreciation-report/${id}`;
    return this.http.post<any>(url, map);
  }
  public getSaleReportList(map: SaleModel) {
    const url = this.apiUrl + `/reports/sale-report-data`;
    return this.http.post<any>(url, map);
  }
  public getMissedSavingSaleReportList(map: MissedSavingModel) {
    const url = this.apiUrl + `/reports/missed-saving-report-data`;
    return this.http.post<any>(url, map);
  }
  public getCorpVsRetailFareReportList(map: CorpVsRetailModel) {
    const url = this.apiUrl + `/reports/corp-retail-report-data`;
    return this.http.post<any>(url, map);
  }

  public getLeadTimeReportList(map: LeadTimeModel) {
    const url = this.apiUrl + `/reports/lead-time-report-data`;
    return this.http.post<any>(url, map);
  }
  public getProductWiseReportList(map: ProductWiseReportModel) {
    const url = this.apiUrl + `/reports/product-wise-report-data`;
    return this.http.post<any>(url, map);
  }
  public getCanceReissueReportList(map: CancelReissueReportModel) {
    const url = this.apiUrl + `/reports/cancel-reissue-report-data`;
    return this.http.post<any>(url, map);
  }
  public getDestinationReportList(map: DestinationWiseReportModel) {
    const url = this.apiUrl + `/reports/destination-wise-report-data`;
    return this.http.post<any>(url, map);
  }
  public getCarrierReportList(map: CarrierWiseReportModel) {
    const url = this.apiUrl + `/reports/carrier-wise-report-data`;
    return this.http.post<any>(url, map);
  }
  public getHotelReportList(map: HotelWiseReportModel) {
    const url = this.apiUrl + `/reports/hotel-wise-report-data`;
    return this.http.post<any>(url, map);
  }

  public getCommonDashboard(map: CommonDashboardModel) {
    const url = this.apiUrl + `/reports/common-dashboard-data/report`;
    return this.http.post<any>(url, map);
  }



  public deleteAppreciationData(id) {

    return this.http.get<any>(`${this.apiUrl}/reports/deletelog-appreciation/${id}`);
  }

  savecorporate(id:string,addCorporate: CorporateRawData) {
    return this.http.post(this.apiUrl + `/corporate/save/${id}`, addCorporate);
  }

  public corporateNameList() {
    const url = this.apiUrl + `/corporate/corporate-list`;
    return this.http.get<any>(url);
  }
  getBranchList() {
    return this.http.get<any>(`${this.apiUrl}/request/data/branch-list`);
  }

  getManagerList() {
    return this.http.get<any>(`${this.apiUrl}/request/data/manager-list`);
  }

  getempCodeList(id) {
    return this.http.get<any>(`${this.apiUrl}/request/data/empcode-list/${id}`);
  }

  getmanagerName(id) {
    return this.http.get<any>(`${this.apiUrl}/request/data/manager-name/${id}`);
  }

  getRegionList() {
    return this.http.get<any>(`${this.apiUrl}/request/data/region-list`);
  }
  getAcptList(){
    return this.http.get<any>(`${this.apiUrl}/request/data/acpt-list`);
  }

  getServiceList(){
    return this.http.get<any>(`${this.apiUrl}/request/data/service-list`); 
  }
  getRootCauseList(){
    return this.http.get<any>(`${this.apiUrl}/request/data/root-cause-list`);   
  }
  getReasonList(){
    return this.http.get<any>(`${this.apiUrl}/request/data/reason-list`); 
  }
  getUserList() {
    return this.http.get<any>(`${this.apiUrl}/user/all`);
  }
  delete(id: number) {
    return this.http.delete(`${this.apiUrl}/user/delete/${id}`, { observe: 'response' })
  }
  update(id: number) {
    return this.http.put(`${this.apiUrl}/api/user/update/${id}`, { observe: 'response' });
  }
  public isActiveOrDeactive(status: Boolean, id) {
    const url = this.apiUrl + `/reports/status/update/${id}/${status}`;
    return this.http.post<any>(url,{ observe: 'response' });
  }
  deactivateAorporate(id){
    return this.http.get<any>(`${this.apiUrl}/reports/deActivateCorporate/${id}`);
  }

  findCorporateById(id){
    return this.http.get<any>(`${this.apiUrl}/corporate/findById/${id}`);
  }
  updateCorporate(id:number,editCorporateModel:EditCorporateModel){
    return this.http.put(this.apiUrl + `/corporate/update/${id}`, editCorporateModel);
  }

}

